module.exports = __webpack_public_path__ + "img/12_100.03fbbd0b.png";